module.exports = __webpack_public_path__ + "img/Vehícular.1a91de05.png";